import { NotchEraser } from '@Map/shared/NotchEraser';
import type { Border, Notch } from '@Model/MapModelsView';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

type Props = {
  x: number;
  y: number;
  borderSet: Border[];
  onPress: () => void;
  cellSize: number;
  gapSize: number;
  borderRadius: number;
  notches?: Notch[];
};

export const MapGridCell = observer(function MapGridCell({
  x,
  y,
  borderSet,
  cellSize,
  gapSize,
  borderRadius,
  onPress,
  notches = [],
}: Props) {
  return (
    <Pressable onPress={onPress}>
      <View
        style={[
          styles.view,
          // eslint-disable-next-line react-native/no-inline-styles
          {
            top: y * cellSize,
            left: x * cellSize,
            width: cellSize,
            height: cellSize,
            borderTopWidth: borderSet.includes('top') ? gapSize : 0,
            borderLeftWidth: borderSet.includes('left') ? gapSize : 0,
            borderBottomWidth: borderSet.includes('bottom') ? gapSize : 0,
            borderRightWidth: borderSet.includes('right') ? gapSize : 0,
            borderTopLeftRadius:
              borderSet.includes('top') && borderSet.includes('left')
                ? borderRadius
                : 0,
            borderTopRightRadius:
              borderSet.includes('top') && borderSet.includes('right')
                ? borderRadius
                : 0,
            borderBottomRightRadius:
              borderSet.includes('bottom') && borderSet.includes('right')
                ? borderRadius
                : 0,
            borderBottomLeftRadius:
              borderSet.includes('bottom') && borderSet.includes('left')
                ? borderRadius
                : 0,
          },
        ]}
      >
        {notches.map((notch) => (
          <NotchEraser size={gapSize * 2} type={notch} key={notch} />
        ))}
      </View>
    </Pressable>
  );
});

const styles = StyleSheet.create({
  view: {
    position: 'absolute',
    borderStyle: 'solid',
    borderColor: 'white',
    backgroundColor: OwnableTheme.colors.lightGray,
  },
});
